export const getItineraryImageEndpoint = (itinCode: string) => `https://www.msccruises.com/images/msc/iti/itin/${itinCode}.jpg`
